// The "never billed until you build" rail — the OTO page's trust device.
//
// Four moments, three of them $0. The buyer controls the only one that
// isn't. The activation node carries the single coral accent: it is the
// moment that belongs to them.

const MOMENTS: Array<{
  label: string;
  title: string;
  detail: string;
  amount: string;
  accent?: boolean;
}> = [
  {
    label: 'Today',
    title: 'Upgrade attached in one click',
    detail: 'Uses the card from your purchase — nothing new to enter, nothing charged. Your trial waits until you start it.',
    amount: '$0',
  },
  {
    label: 'Your Blueprint',
    title: 'Sessions run on us',
    detail: 'Go as deep as you want. No clock is running.',
    amount: '$0',
  },
  {
    label: 'You decide',
    title: 'You click "Set it up in VibeControl"',
    detail: 'Your 14-day trial starts here — and 2,500 credits of agent work land with it.',
    amount: '$0',
    accent: true,
  },
  {
    label: 'Day 14 of the trial',
    title: 'Standard continues at $97/mo',
    detail: 'Or cancel in settings and keep the course, your Blueprint, and everything you built.',
    amount: '$97/mo',
  },
];

export function BillingTimeline() {
  return (
    <div aria-label="When you would ever be billed">
      {/* Desktop: horizontal rail */}
      <ol className="relative hidden gap-4 md:grid md:grid-cols-4">
        <div aria-hidden="true" className="fv2-rail absolute left-0 right-0 top-[7px] h-px bg-gradient-to-r from-brand-teal/60 via-white/25 to-brand-coral/60" />
        {MOMENTS.map((m) => (
          <li key={m.title} className="relative pt-6">
            <span
              aria-hidden="true"
              className={`absolute left-0 top-0 h-[15px] w-[15px] rounded-full border-2 ${
                m.accent
                  ? 'border-brand-coral bg-brand-coral/25 shadow-[0_0_18px_rgba(254,89,99,0.55)]'
                  : 'border-white/35 bg-[#0b0f16]'
              }`}
            />
            <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-slate-500">{m.label}</p>
            <p className={`mt-2 font-mono text-xl font-semibold tabular-nums ${m.accent ? 'text-brand-coral' : 'text-white'}`}>
              {m.amount}
            </p>
            <p className="mt-2 text-sm font-semibold leading-5 text-white">{m.title}</p>
            <p className="mt-1.5 text-sm leading-6 text-slate-400">{m.detail}</p>
          </li>
        ))}
      </ol>

      {/* Mobile: vertical rail */}
      <ol className="relative grid gap-7 border-l border-white/15 pl-6 md:hidden">
        {MOMENTS.map((m) => (
          <li key={m.title} className="relative">
            <span
              aria-hidden="true"
              className={`absolute -left-[31px] top-1 h-[13px] w-[13px] rounded-full border-2 ${
                m.accent
                  ? 'border-brand-coral bg-brand-coral/25 shadow-[0_0_14px_rgba(254,89,99,0.55)]'
                  : 'border-white/35 bg-[#0b0f16]'
              }`}
            />
            <div className="flex items-baseline justify-between gap-3">
              <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-slate-500">{m.label}</p>
              <p className={`font-mono text-base font-semibold tabular-nums ${m.accent ? 'text-brand-coral' : 'text-white'}`}>
                {m.amount}
              </p>
            </div>
            <p className="mt-1.5 text-sm font-semibold text-white">{m.title}</p>
            <p className="mt-1 text-sm leading-6 text-slate-400">{m.detail}</p>
          </li>
        ))}
      </ol>
    </div>
  );
}
